import {
  REGISTER_USER_REQUEST,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_ERROR,
  RESET_ERROR_STATE,
  KICKBOX_SUCCESS,
  KICKBOX_ERROR,
  REGISTER_USER_RECAPTCHA,
  ADD_ADDRESS_ERROR,
} from '../actions/constants'

const initialState = {
  registerSuccess: false,
  registerError: false,
  regErrorCode: '',
  kickboxError: false,
  postcode: '',
  pwdStrength: 'Weak',
  emailValidStatus: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_USER_REQUEST:
      return { ...state, isLoading: true, pwdStrength: action.payload }
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        registerSuccess: action.registerSucc,
        registerError: false,
        postcode: action.postcode.toUpperCase() || 'default',
        ...action.response,
      }
    case REGISTER_USER_RECAPTCHA:
      return {
        ...state,
        isLoading: false,
        registerSuccess: action.registerSucc,
        registerError: false,
        ...action.response,
      }
    case REGISTER_USER_ERROR:
      return {
        ...state,
        ...action.response,
        registerError: true,
        regErrorCode: action.response.errorCode,
      }
    case ADD_ADDRESS_ERROR:
      return {
        ...state,
        isLoading: false,
        ...action.response,
      }
    case RESET_ERROR_STATE:
      return {
        ...state,
        registerError: false,
      }
    case KICKBOX_SUCCESS:
      return {
        ...state,
        kickboxError: false,
        emailValidStatus: action.response.validationStatus,
      }
    case KICKBOX_ERROR:
      return {
        ...state,
        kickboxError: action.kickboxError,
        emailValidStatus: action.response.validationStatus,
        ...action.response,
      }
    default:
      return state
  }
}
